import { Trans, useTranslation } from "react-i18next";
import { ITerritorios } from "../../../interfaces/Territorios";
import { useEffect, useState } from "react";
import { ChartContainerLoader } from "../../../components/Generic/Charts";
import { getTerritorios } from "../../../api/territorios";

const Territorios: React.FC<{
    code?: string
}> = ({ code }) => {
    const { t, i18n } = useTranslation("translation", {
        keyPrefix: "territorios",
    });

    const [territorios, setTerritorios] = useState<ITerritorios[]>()

    useEffect(() => {
        getTerritorios(code)
            .then((res) => {
                setTerritorios(res)
            })

        return () => {
            setTerritorios(undefined)
        }
    }, [code])

    if (!territorios) {
        return <ChartContainerLoader colSize="12" />;
    }

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">{t("title")}</h5>
                <div className="row mb-3">
                    <div className="col">
                        <Trans i18nKey="territorios.cantidad" values={{ cantTerritorios: territorios.length }}>
                            <small>
                                Se encontraron <strong></strong> territorios
                            </small>
                        </Trans>

                    </div>
                </div>
                <ul className="row" style={{ listStyleType: "none", paddingLeft: "0" }}>
                    {
                        territorios.map((territorio, key) => {
                            return (
                                <li className="com-md-3 col-sm-4 col-xs-12" key={key}>
                                    <div className="card">
                                        <div className="card-body">
                                            <h6>{territorio.descripcion}</h6>
                                            <small className="card-subtitle text-body-secondary">{territorio.nombrePais}</small>
                                        </div>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
}

export default Territorios